import { Box, Typography } from "@material-ui/core";
import React from "react";

import { InvestmentStyleDiagnosisRequestHoldingPeriodEnum as HoldingEnum } from "@/api/generated";
import {
  DIAGNOSIS_QUESTION_TEXT,
  HOLDING_OPTIONS,
} from "@/constants/investmentStyleDiagnosisQuestions";

import { DiagnosisInvestmentStyleCheckboxList } from "../DiagnosisInvestmentStyleCheckboxList";

import { useStepStyles } from "./stepStyles";

type HoldingStepProps = {
  holdingPeriod: HoldingEnum | null;
  onHoldingPeriodChange: (next: HoldingEnum | null) => void;
};

const HoldingStep: React.FC<HoldingStepProps> = ({ holdingPeriod, onHoldingPeriodChange }) => {
  const classes = useStepStyles();
  return (
    <>
      <Typography className={classes.title}>保有・売却についての考え方</Typography>
      <Typography className={classes.description}>{DIAGNOSIS_QUESTION_TEXT[7]}</Typography>
      <Box className={classes.inputArea}>
        <DiagnosisInvestmentStyleCheckboxList
          options={HOLDING_OPTIONS}
          selected={holdingPeriod ? [holdingPeriod] : []}
          single
          onChange={(next) => onHoldingPeriodChange(next[0] ?? null)}
        />
      </Box>
    </>
  );
};

export default HoldingStep;
